export var StateTypes;

(function (StateTypes) {
  StateTypes["NONE"] = "NONE";
  StateTypes["FORM_VISIBLE"] = "FORM_VISIBLE";
  StateTypes["AWAIT_LOGIN"] = "AWAIT_LOGIN";
})(StateTypes || (StateTypes = {}));

export var ErrorTypes;

(function (ErrorTypes) {
  ErrorTypes["USER_ALREADY_LOGGED_IN"] = "USER_ALREADY_LOGGED_IN";
  ErrorTypes["INVALID_STATE"] = "INVALID_STATE";
})(ErrorTypes || (ErrorTypes = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnVtcy50cyJdLCJuYW1lcyI6WyJTdGF0ZVR5cGVzIiwiRXJyb3JUeXBlcyJdLCJtYXBwaW5ncyI6IkFBQUEsV0FBWUEsVUFBWjs7V0FBWUEsVTtBQUFBQSxFQUFBQSxVO0FBQUFBLEVBQUFBLFU7QUFBQUEsRUFBQUEsVTtHQUFBQSxVLEtBQUFBLFU7O0FBTVosV0FBWUMsVUFBWjs7V0FBWUEsVTtBQUFBQSxFQUFBQSxVO0FBQUFBLEVBQUFBLFU7R0FBQUEsVSxLQUFBQSxVIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gU3RhdGVUeXBlcyB7XG4gIE5PTkUgPSAnTk9ORScsXG4gIEZPUk1fVklTSUJMRSA9ICdGT1JNX1ZJU0lCTEUnLFxuICBBV0FJVF9MT0dJTiA9ICdBV0FJVF9MT0dJTicsXG59XG5cbmV4cG9ydCBlbnVtIEVycm9yVHlwZXMge1xuICBVU0VSX0FMUkVBRFlfTE9HR0VEX0lOID0gJ1VTRVJfQUxSRUFEWV9MT0dHRURfSU4nLFxuICBJTlZBTElEX1NUQVRFID0gJ0lOVkFMSURfU1RBVEUnLFxufVxuIl19